export const removeFcmToken = async () => {
    try {
        await fetch(`${process.env.REACT_APP_PRODUCTION_URL}/saveFCMToken`, {
            headers: {
                'Content-type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify({
                USERNAME: localStorage.getItem('USERNAME'),
                PASSWORD: localStorage.getItem('PASSWORD'),
                FCM_TOKEN: '',
            }),
        });
    } catch (error) {
        console.log(error, "error");
    }
}